import moment from "moment";
import React from "react";
import { useAuth } from "../context/Auth.context";
import { capitalizeFirstLetter, formatDate } from "./Utils";
import { forwardRef } from "react";

const VerificationDocument = forwardRef(({ customer, insuranceList }, ref) => {
  console.log("customerdetailsCart", customer, insuranceList);
  const auth = useAuth();
  const getVehicleDetails = (vehicles, status) => {
    const vehicle = vehicles.find(
      (vehicle) => vehicle.vehicle_status_id === status
    );
    if (vehicle) {
      if (vehicle.year || vehicle.make || vehicle.model) {
        return {
          year: vehicle.year || "N/A",
          make: vehicle.make || "N/A",
          model: vehicle.model || "N/A",
          vin: vehicle.vin || "",
        };
      } else {
        return {
          year: "N/A",
          make: "N/A",
          model: "N/A",
          vin: "",
        };
      }
    } else {
      return {
        year: "N/A",
        make: "N/A",
        model: "N/A",
        vin: "",
      };
    }
  };
  let data = {
    dealershipName: auth.user.dealership_name,
    date: formatDate(customer.customer.date),
    customer: {
      firstName: customer.customer.first_name,
      middleName: "",
      lastName: customer.customer.last_name,
      contactNumber: customer.contact.mobile_number || "N/A",
      address: customer.contact.address || "N/A",
    },
    vehicle: {
      year: getVehicleDetails(customer.vehicles, 1).year,
      make: getVehicleDetails(customer.vehicles, 1).make,
      model: getVehicleDetails(customer.vehicles, 1).model,
      vin: getVehicleDetails(customer.vehicles, 1).vin,
    },
    insurance: {
      carrier: (insuranceList?.policy?.carrier_name).toUpperCase(),
      policyNumber: insuranceList?.policy?.policy_number,
      effectiveFrom: moment(insuranceList?.policy?.policy_begin).format(
        "MM/DD/YYYY"
      ),
      effectiveTo: moment(insuranceList?.policy?.policy_end).format(
        "MM/DD/YYYY"
      ),
      compDeductible: insuranceList?.policy?.comp_deductible,
      collisionDeductible: insuranceList?.policy?.collision_deductible,
    },
    employee: {
      fullName:
        customer.employee.employee_firstname +
        " " +
        customer.employee.employee_lastname,
    },
    agent: {
      fullName: customer.agentDetail?.full_name,
      agencyName: customer.agentDetail?.agency_name,
      address: customer.agentDetail?.full_address || "N/A",
      contactNumber: customer.agentDetail?.phone_number || "N/A",
      email: customer.agentDetail?.email || "N/A",
    },
  };

  return (
    <div ref={ref}>
      <style>{`
    table,th,td{
     padding:1px;
     font-size:13px
    }

    p{
    font-size:13px;
    }
  `}</style>
      <div
        style={{
          padding: "16px",
          marginLeft: "12px",
          marginRight: "12px",
          marginTop: "16px",
          border: "1px solid black",
          overflowX: "scroll",
        }}
      >
        <h4 style={{ marginTop: "0px", marginBottom: "10px" }}>
          Dealership: {data.dealershipName}
        </h4>
        <h3
          style={{
            textAlign: "center",
            marginTop: "6px",
            marginBottom: "10px",
          }}
        >
          Agreement Regarding Accidental Physical Damage Insurance
        </h3>
        <p>
          CREDITOR is the entity that is providing the finance or lease for your
          vehicle.
        </p>
        <p style={{ textAlign: "justify", textJustify: "inter-word" }}>
          I understand that the retail, lease, or purchase agreement requires
          that the vehicle listed below be continuously covered with insurance
          against the risks of fire, theft, and collision while the terms of
          financing or lease agreement are in effect. I also understand that I
          may choose any insurance company authorized to do business in my
          state. The insurance must cover the CREDITOR’s interest in the vehicle
          and will be referred to as “Collision and Comprehensive Coverage”. I
          further understand the CREDITOR must be named on my insurance policy
          as an additional insured and as a loss payee. I agree to provide proof
          of this insurance, including a loss-payable endorsement, to the
          CREDITOR within thirty (30) days of the date on this agreement.
        </p>
        {/* <br /> */}
        <table style={{ width: "100%", marginTop: "6px" }}>
          <tr>
            <td
              style={{
                fontWeight: "bold",
                width: "34%",
              }}
            >
              Named Insured
            </td>
            <td colSpan={4}>
              {capitalizeFirstLetter(data.customer.firstName) +
                " " +
                capitalizeFirstLetter(data.customer.lastName)}
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold", width: "34%" }}>Address</td>
            <td colSpan={4}>{data.customer.address}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold", width: "34%" }}>Contact Number</td>
            <td colSpan={4}>{data.customer.contactNumber}</td>
          </tr>
          {/* <br /> */}
          <tr>
            <td></td>
            <td>Year</td>
            <td>Make</td>
            <td>Model</td>
            <td>VIN</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold" }}>Vehicle Purchased</td>
            <td style={{ width: "17.5%" }}>{data.vehicle.year}</td>
            <td style={{ width: "17.5%" }}>{data.vehicle.make}</td>
            <td style={{ width: "17.5%" }}>{data.vehicle.model}</td>
            <td style={{ width: "17.5%" }}>{data.vehicle.vin}</td>
          </tr>

          {/* <br /> */}

          <tr>
            <td style={{ fontWeight: "bold" }}>Insurance Carrier</td>
            <td colSpan={4}>{data.insurance.carrier}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold" }}>Phone Number</td>
            <td colSpan={4}>Electronically Verified</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold" }}>Policy Number</td>
            <td colSpan={4}>{data.insurance.policyNumber}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold" }}>Effective Dates</td>
            <td colSpan={2}> From: {data.insurance.effectiveFrom}</td>
            <td colSpan={2}> To: {data.insurance.effectiveTo}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold" }}>Comprehensive Deductible</td>
            <td>{`$ ` + data.insurance?.compDeductible || "N/A"}</td>
            <td colSpan={2} style={{ fontWeight: "bold" }}>
              Collision Deductible
            </td>
            <td>{`$ ` + data.insurance?.collisionDeductible || "N/A"}</td>
          </tr>
          <br />
          <tr>
            <td colSpan={5} style={{ fontWeight: "bold" }}>
              Agent Information (If electronically available)
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold" }}>Name</td>
            <td colSpan={4}>
              {data.agent.fullName || data.agent.agencyName || "N/A"}
            </td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold" }}>Address</td>
            <td colSpan={4}>{data.agent.address}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold" }}>Phone</td>
            <td colSpan={4}>{data.agent.contactNumber}</td>
          </tr>
          <tr>
            <td style={{ fontWeight: "bold" }}>Email</td>
            <td colSpan={4}>{data.agent.email}</td>
          </tr>
        </table>

        <p>
          I (WE) have read this agreement, have received a copy of it, and
          understand a agree to its terms.
        </p>

        <table style={{ width: "100%" }}>
          <tr>
            <td>Buyer's Signature</td>
            <td style={{ textAlign: "center" }}>
              __________________________________________
            </td>
            <td>Date: </td>
            <td>{data.date}</td>
          </tr>
          <tr>
            <td>Dealer's Signature</td>
            <td style={{ textAlign: "center" }}>
              __________________________________________
            </td>
            <td>Date: </td>
            <td>{data.date}</td>
          </tr>
          {/* <tr>
            <td></td>
            <td style={{ textAlign: "center", fontSize: 12 }}>
              ( {data.employee.fullName} )
            </td>
          </tr> */}
        </table>

        {/* <br /> */}

        <p
          style={{ fontWeight: "bold", marginTop: "6px", marginBottom: "6px" }}
        >
          Failure to maintain insurance
        </p>
        <p style={{ textAlign: "justify", textJustify: "inter-word" }}>
          If I do not obtain Collision and Comprehensive Coverage, do not
          maintain Collision and Comprehensive coverage for the duration of the
          financing contract, or do not provide the required proof of Collison
          and Comprehensive Coverage to the CREDITOR, the CREDITOR has the
          option of obtaining insurance for its own protection
          <i> at my expense, </i>if permitted by state law to do so. The
          CREDITOR may only obtain Collision and Comprehensive Coverage to
          protect its interest in the vehicle. This insurance may not: i.protect
          you if you or others are injured ii.cover your liability for damage to
          other’s property; or iii. meet your requirements under the laws of
          your state to maintain no-fault or liability insurance.
        </p>
        <p
          style={{
            fontWeight: "bold",
            textAlign: "justify",
            textJustify: "inter-word",
          }}
        >
          NOTICE: Dealership cannot add or remove a vehicle from your insurance
          policy. You must contact your agent or carrier to add or remove a
          vehicle. You must do this immediately to protect yourself and the
          CREDITOR.
        </p>

        {/* <br /> */}

        <table style={{ width: "100%", marginTop: "6px" }}>
          <tr>
            <td>Buyer's Signature</td>
            <td style={{ textAlign: "center" }}>
              __________________________________________
            </td>
            <td>Date: </td>
            <td>{data.date}</td>
          </tr>
        </table>
      </div>
    </div>
  );
});

export default VerificationDocument;
